export default __webpack_public_path__ + "static/media/ant7.dbff0668.jpg";